import { API_BASE_URL, API_URL, UPLOAD_BASE_URL } from "./constants";
import { PROTOCOL_REGEX } from "./regex";

export const getDomainFromUrl = (url) => {
  return url && url.replace(PROTOCOL_REGEX, "");
};

export const redirectToPaymentPort = (invoiceId) => {
  const paymentLink = document.createElement("a");
  paymentLink.id = "paymentLink";
  paymentLink.href = API_BASE_URL + `/ipg/vandar/pay?invoiceId=${invoiceId}`;
  document.body.appendChild(paymentLink);
  const paymentLinkElem = document.getElementById("paymentLink");
  paymentLinkElem.click();
  paymentLinkElem.parentNode.removeChild(paymentLinkElem);
};

export const redirectToAutoUpgrade = (url) => {
  const paymentLink = document.createElement("a");
  paymentLink.id = "paymentLink";
  paymentLink.href = url;
  document.body.appendChild(paymentLink);
  const paymentLinkElem = document.getElementById("paymentLink");
  paymentLinkElem.click();
  paymentLinkElem.parentNode.removeChild(paymentLinkElem);
};

/**
 * As we have kind of inconsistency  in returned URLs from backend. so a normalizer is required.
 * This function checks for these 3 unnormal urls and normalizes them:
 *
 * 1 - urls without base url (starting with /)
 * 2-  urls without base url (not starting with /)
 * 3 - urlls with two base urls
 *
 * @param {string} url - url address
 * @param {string} baseUrl - base url which is by default the API url
 *
 * @returns {string}
 */
export const getNormalizedUrl = (url = "", baseUrl = API_URL) => {
  // When operator manually uploads a photo it's base URL will be different.
  // TODO: I think best practice will be to get all avatars by their base URL from backend and remove this redundant burden from Front-End's shoulders
  const isAvatarUploadedByOperator = /^[0-9a-fA-F]{24}$/.test(url);

  if (isAvatarUploadedByOperator) return `${UPLOAD_BASE_URL}/${url}?size=small`;

  if (!url.startsWith("http")) {
    url = `${baseUrl}/${url.replace(/^\/+/, "")}`;
  }

  const baseUrlPattern = new RegExp(`(${baseUrl})\\/\\1+`);

  return url.replace(baseUrlPattern, baseUrl);
};

// this function returns decoded urls if they exist.
// it is mostly used in decoding `lastPage` and `referrer` parameter when user messages in a page that has special characters in the URL
export const getDecodedURL = (url) => {
  try {
    if (url) {
      return decodeURI(url);
    }
    return url;
    // in case of malformed url
  } catch (error) {
    return url;
  }
};
